// import { version as isVue3 } from 'vue'

const ripple = {
  bind(el, binding) {
    rippleFunc(el, binding);
  },
  created(el, binding) {
    rippleFunc(el, binding);
  },
};

function rippleFunc(el, binding) {
  let isDark = false;

  if (binding.modifiers.off) return;
  if (binding.value !== undefined) {
    if (binding.value === false || binding.value === "off") return;
    if (binding.value === "dark") isDark = true;
  }

  el.addEventListener("click", (e) => {
    /**
     * ripple with custom class
     */
    if (typeof binding.value === "object") {
      if ("class" in binding.value) {
        return setRipple(e, el, binding.value.class);
      }
    }

    /**
     * ripple by modifiers
     */
    if (binding.value !== "light" && (isDark || binding.value === "dark")) {
      return setRipple(e, el, "animation-ripple--dark");
    }

    /**
     * light ripple
     */
    return setRipple(e, el, "animation-ripple--light");
  });
}

function setRipple(e, el, className) {
  const ripple = document.createElement("span");
  ripple.classList.add("animation-ripple", className);
  el.style.position = "relative";
  el.style.overflow = "hidden";
  ripple.style.left = e.offsetX + "px";
  ripple.style.top = e.offsetY + "px";
  ripple.style.setProperty("--scale", el.offsetWidth);
  el.appendChild(ripple);
  setTimeout(() => {
    el.removeChild(ripple);
  }, 300);
}

export default ripple;
